<script lang="ts">
    import s from './style.module.css';
</script>

<div class={s.steps}>
    <div class={s.step}>
        <span class={s.number}>1</span>
        <p class={s.text}>Scan the QR code with your phone</p>
    </div>
    <div class={s.step}>
        <span class={s.number}>2</span>
        <p class={s.text}>Confirm your<br />sign up</p>
    </div>
    <div class={s.step}>
        <span class={s.number}>3</span>
        <p class={s.text}>Receive coupon<br />& start saving!</p>
    </div>
</div>
